// Based on TiMessengerTestTreiber.yaml 2.0.0
import { inject, Injectable } from '@angular/core';
import { MatrixService } from '../matrix/matrix.service';
import { MatrixKeyInfo } from '../../../shared-api/matrixKeyInfo';
import { KeyExchangeService as ApiKeyExchangeService } from '../../../shared-api/keyExchange.service';
import { VerificationService } from '../verification/verification.service';

@Injectable({
  providedIn: 'root'
})
/**
 * Der KeyExchangeService stellt den Schlüsselaustausch bereit.
 * Implementation of the mandatory KeyExchange API of the gematik TI-M Testtreiber
 * Umgesetze AFOs:
 * A_25363 - Testtreiber-Modul
 * A_25361 - keine Modifikation der Inhalte
 */
export class KeyExchangeService implements ApiKeyExchangeService {
  private readonly matrix = inject(MatrixService);
  private readonly verificationService = inject(VerificationService);

  /**
   * Exports secret key for device synchronization. The key could be in any format but has to be understood by every provided test-driver-api per distributor!
   */

  public async keyExport(): Promise<MatrixKeyInfo> {
    let mxid: string;
    try {
      mxid = this.matrix.getUserId();
    } catch {
      throw new Error('Key export failed: No logged-in user available.');
    }
    let key: string;
    try {
      key = this.matrix.getVerificationPassword();
    } catch {
      key = '<no verification key set>';
    }

    return {
      mxId: { mxid },
      key
    };
  }

  /**
   * Imports secret key and executes synchronization
   * @param matrixKeyInfo
   */
  public async keyImport(matrixKeyInfo: MatrixKeyInfo): Promise<void> {
    if (!matrixKeyInfo) {
      throw new Error('Required parameter matrixKeyInfo was null or undefined when calling keyImport.');
    }

    if (!matrixKeyInfo.key) {
      throw new Error('MatrixKeyInfo.key is required when calling keyImport.');
    }

    this.matrix.setVerificationPassword(matrixKeyInfo.key);

    try {
      await this.verificationService.initHydrateDevice();
    } finally {
      this.matrix.setVerificationPassword(undefined);
    }
  }
}
